import { Avatar, Chip } from "@nextui-org/react";
import styles from "./AccountCard.module.scss";
import { getInitials } from "../../../../utils";
import { UnifiedStates } from "../../types/types";

type ColorType =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "danger"
  | undefined;

const AccountCard = ({
  legalName,
  alias,
  cvu,
  isSelected,
  onClick,
  isMirrored,
  accountNumber,
  state,
  customBottomComponent,
  customSideComponent,
  isDisabled = false,
}: {
  legalName: string;
  alias?: string;
  cvu?: string;
  isSelected: boolean;
  isMirrored?: boolean;
  accountNumber?: string;
  onClick: () => void;
  state?: UnifiedStates;
  customBottomComponent?: React.ReactNode;
  customSideComponent?: React.ReactNode;
  isDisabled?: boolean;
}) => {
  const {
    container,
    icon,
    summary,
    selected,
    mirrored,
    disabled,
    notDisabledComponentWrapper,
  } = styles;

  const handleChipState = () => {
    let text = "";
    let color: ColorType;
    switch (state) {
      case "UNIFIED":
        text = "Unificada";
        color = "primary";
        break;
      case "FAILED":
        text = "Rechazada";
        color = "danger";
        break;
      case "IN_PROCESS":
      case "ACCOUNT_CREATION_PENDING":
        text = "Unificación en proceso";
        color = "warning";
        break;
      case "ONBOARDING_IN_PROCESS":
        text = "En proceso";
        color = "warning";
        break;
    }

    return { text, color };
  };

  const { text, color } = handleChipState();

  return (
    <div
      className={`${container} ${isSelected ? selected : ""} ${
        isMirrored ? mirrored : ""
      } ${isDisabled ? disabled : ""}`}
      onClick={isMirrored || isDisabled ? undefined : onClick}
    >
      <div className={icon}>
        <Avatar
          className="bg-primary-500 mr-3 text-white"
          size="md"
          name={getInitials(legalName)}
        />
      </div>
      <div className={summary}>
        <div>
          <h2>{legalName}</h2>
          {customSideComponent && (
            <div className={notDisabledComponentWrapper}>
              {customSideComponent}
            </div>
          )}
          {isMirrored && (
            <Chip color="primary" radius="sm" size="sm" variant="solid">
              Unificada
            </Chip>
          )}
          {text && (
            <Chip color={color} radius="sm" size="sm" variant="solid">
              {text}
            </Chip>
          )}
        </div>
        {accountNumber && <p>{accountNumber}</p>}
        {alias && cvu && (
          <p>
            {alias} - CVU {cvu}
          </p>
        )}
        {customBottomComponent && (
          <div className={notDisabledComponentWrapper}>
            {customBottomComponent}
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountCard;
